import { Button, Grid, Link } from '@mui/material'
import axios from 'axios'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import PageHeader from '../helper/PageHeader'
import { PolicyDialog } from '../helper/Dialogs'
import { withTranslation } from 'react-i18next';
import { authContext } from '../../context/AuthContext'
import { englishCourseId, spanishCourseId } from '../../constants/global'
import { Trans } from 'react-i18next';

const SelectCourseDVD = props => {
    const history = useHistory()

    const userMain = useContext(authContext)
    const username = userMain.user.username

    const [englishCourse, setEnglishCourse] = useState(null)
    const [spanishCourse, setSpanish] = useState(null)
    const [dialogOpen, setDialogOpen] = useState(false)

    const [currentCredit, setCurrentCredit] = useState((history.location.state && history.location.state.credit) || null)

    console.log("UserMain", userMain, "Credts", currentCredit)

    const mounted = useRef(true)


    useEffect(() => {
        async function getDetails() {
            const res = await await axios.all([
                axios.get('/api/course/'+englishCourseId),
                axios.get('/api/course/'+spanishCourseId)
            ])

            let newCurrentCred
            if (!currentCredit) {
                const res2 = await axios.get('/api/user/credit/' + username)
                newCurrentCred = res2.data.user.credit
            }

            if (mounted.current) {
                setEnglishCourse(res[0].data)
                setSpanish(res[1].data)
                if (newCurrentCred) {
                    console.log("Resetting credit amount")
                    setCurrentCredit(newCurrentCred)
                }

            }

        }

        getDetails()
        return () => mounted.current = false
    })


    const onPolicies = () => {
        setDialogOpen(true)
    }

    // check if dvd or zoom, if so go to the code page. Otherwise open dialog for payment
    const onProceed = (data) => {
            const { id, label } = data.course

            const lang = (id === englishCourseId) ? 'English' : 'Spanish'
            history.push('/courses/DVD/code', { id, lang, label/*, modules*/ })
    }

    return (
        <>
            <PageHeader
                title={props.t('trainingCourses.titleDVD')}
                cancel={history.goBack}
            />
             <PolicyDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
            />
         
            <Button variant='contained' color='primary' onClick={onPolicies}>{props.t('trainingCourses.viewPolicies')}</Button>
            <br />
            <br />
            <p>{props.t('trainingCourses.paragraph2')}<Link onClick={onPolicies}>{props.t('trainingCourses.linkPoliciesText')}</Link>{props.t('trainingCourses.paragraph3')}</p>
            <p> <Trans
            i18nKey={"trainingCourses.dvdParagraph"}
            components={[<a href="https://ffl.ifas.ufl.edu/ffl-and-you/gi-bmp-program/dvd-order/">placeholder</a>]}
            /> </p>
           <p>{props.t('trainingCourses.pleaseChoose')}</p>
            <Grid container direction="row" justifyContent="space-around" alignItems="center">
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={() =>onProceed(englishCourse)}
                    >
                    {props.t('trainingCourses.english')}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={() =>onProceed(spanishCourse)}
                    >
                    {props.t('trainingCourses.spanish')}
                </Button>
            </Grid>
            <br/>
            <Grid container  justifyContent="space-around"  alignItems="center">
            <Grid item xs={12} md={8} style={{ textAlign: "left", alignSelf: "flex-start" }}>
                <ul>
                    <li> {props.t('trainingCourses.dvdDetail1')}</li>
                    <li> {props.t('trainingCourses.dvdDetail2')}</li>
                    <li> {props.t('trainingCourses.dvdDetail3')}</li>
                    <li> {props.t('trainingCourses.dvdDetail4')}</li>
                </ul>
                <p>{props.t('trainingCourses.dvdNote')}</p>
            </Grid>
            </Grid>
        </>
    )
}

export default withTranslation()(SelectCourseDVD)

